import { copyTextToClipboard } from "@/lib/utils/copyToClipboard";
import {
  buildStudyGroupPostPath,
  toAbsoluteStudyGroupLink,
} from "@/lib/utils/studyGroupLinks";

export const generatePostLink = (
  studyGroupId: number,
  postId: number,
): string => {
  return toAbsoluteStudyGroupLink(
    buildStudyGroupPostPath(studyGroupId, postId),
  );
};

export const copyPostLinkToClipboard = async (
  studyGroupId: number,
  postId: number,
): Promise<void> => {
  const link = generatePostLink(studyGroupId, postId);
  await copyTextToClipboard(link);
};
